module.exports = __webpack_public_path__ + "media/images/flags/je-52dcec651fbfabffd5f036a14bb46d59.svg";